import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import viewRelatedMainHubThirdParty from './viewRelatedMainHubThirdParty';

export default {
  title: 'Basic Details',
  attributeName: 'app',
  fields: [
    {
      attributeName: 'id',
      helpText: 'Application ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'App ID',
      placeholder: 'Application...',
      disabled: true
    },
    {
      attributeName: 'name',
      helpText: 'Application',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'App Name',
      placeholder: 'Application...',
      disabled: true
    },
    {
      attributeName: 'internalName',
      helpText: 'Internal name of the application',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Internal Name',
      placeholder: 'Internal name...',
      disabled: true
    },
    {
      attributeName: 'posterLogo',
      helpText: 'Default poster logo used as final fallback in hierarchy',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Poster Logo',
      hasSelect: false,
      allowedSizes: [
        { width: 128, height: 128 },
        { width: 192, height: 128 },
      ],
      fileType: ['image/*'],
   },
    {
      attributeName: 'blockingProvider',
      label: 'Blocking Provider',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedMainHubThirdParty,
      default: [],
      helpText: 'Select the authentication provider required to access this MainHub.',
      width: '30rem',
    },
  ],
};